import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-439ef5ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  tabindex: "-1",
  class: "icon-warpit_icon_bus"
}, null, -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_13 = { key: 3 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_15 = { class: "title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  tabindex: "-1",
  class: "icon-warpit_icon_news"
}, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_21 = { class: "title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  tabindex: "-1",
  class: "icon-warpit_icon_clear-sky"
}, null, -1))
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_25 = { class: "flex" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_27 = {
  key: 0,
  class: "flex"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_31 = { class: "title" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  tabindex: "-1",
  class: "icon-warpit_icon_friends"
}, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "inactive"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_36 = ["tabindex"]
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_39 = { class: "title" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  tabindex: "-1",
  class: "icon-warpit_icon_idea"
}, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_42 = { class: "title" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  tabindex: "-1",
  class: "icon-warpit_icon_info"
}, null, -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_right" }, null, -1))
const _hoisted_52 = { class: "lang responsive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_ChangeLanguage = _resolveComponent("ChangeLanguage")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createVNode(_component_Accordion, {
      class: "menuAccordion",
      tabindex: -1
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.mobility")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_ctx.routePlannerEnabled)
                ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                    _hoisted_5,
                    _createVNode(_component_router_link, {
                      tabindex: _ctx.showNavigation ? 0 : -1,
                      to: { name: 'RoutePlanner' },
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.route_planner")), 1)
                      ]),
                      _: 1
                    }, 8, ["tabindex"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _hoisted_6,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'ParkingMap' },
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.parkings")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              (_ctx.bikesEnabled)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _hoisted_8,
                    _createVNode(_component_router_link, {
                      tabindex: _ctx.showNavigation ? 0 : -1,
                      to: { name: 'BikesMap' },
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.bike_sharing")), 1)
                      ]),
                      _: 1
                    }, 8, ["tabindex"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _hoisted_9,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'FindPath' },
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.transport")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_10,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: {
                name: 'TrafficInfoMap',
              },
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.traffic")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              (_ctx.sharedMobilityEnabled)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_router_link, {
                      tabindex: _ctx.showNavigation ? 0 : -1,
                      to: { name: 'SharedMobilityMap' },
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.shared_mobility")), 1)
                      ]),
                      _: 1
                    }, 8, ["tabindex"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.arrayOfFeatures.mobility)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfFeatures.mobility, (mobility) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: mobility.id
                      }, [
                        _hoisted_14,
                        _createVNode(_component_router_link, {
                          tabindex: _ctx.showNavigation ? 0 : -1,
                          to: {
                  name: `Info${mobility.view}`,
                  params: { feature: mobility.collection },
                },
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize(mobility)), 1)
                          ]),
                          _: 2
                        }, 1032, ["tabindex", "to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.news_events")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_17,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'News' },
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.news")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_18,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'Events' },
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.events")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              (_ctx.arrayOfFeatures.news_and_events)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfFeatures.news_and_events, (newsEvents) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: newsEvents.id
                      }, [
                        _hoisted_20,
                        _createVNode(_component_router_link, {
                          to: {
                  name: `Info${newsEvents.view}`,
                  params: { feature: newsEvents.collection },
                },
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize(newsEvents)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.environment")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'Weather' },
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.weather")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'AirQuality' },
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.aqi")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              (_ctx.wasteManagement)
                ? (_openBlock(), _createElementBlock("li", _hoisted_27, [
                    _hoisted_28,
                    _createVNode(_component_router_link, {
                      tabindex: _ctx.showNavigation ? 0 : -1,
                      to: { name: 'EcoIsland' },
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('close')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.waste")), 1)
                      ]),
                      _: 1
                    }, 8, ["tabindex"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.arrayOfFeatures.environment)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfFeatures.environment, (environment) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: environment.id
                      }, [
                        _hoisted_30,
                        _createVNode(_component_router_link, {
                          to: {
                  name: `Info${environment.view}`,
                  params: { feature: environment.collection },
                },
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize(environment)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.community")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_33,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: {
                name: _ctx.$store.getters['user/isLoggedIn'] ? 'Active' : 'Public',
              },
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.surveys")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex", "to"])
              ]),
              (_ctx.$store.getters['user/isLoggedIn'] && _ctx.loyaltyEnabled)
                ? (_openBlock(), _createElementBlock("li", _hoisted_34, [
                    _hoisted_35,
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      href: "#",
                      tabindex: _ctx.showNavigation ? 0 : -1
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.rewards")), 1)
                    ], 8, _hoisted_36)), [
                      [
                        _directive_tooltip,
                        _ctx.$t('rewards.not_available'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.arrayOfFeatures.community)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfFeatures.community, (community) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: community.id
                      }, [
                        _hoisted_38,
                        _createVNode(_component_router_link, {
                          to: {
                  name: `Info${community.view}`,
                  params: { feature: community.collection },
                },
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize(community)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        (_ctx.usesDirectus)
          ? (_openBlock(), _createBlock(_component_AccordionTab, { key: 0 }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("navigation_list.info")), 1)
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfFeatures.features, (feature) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: feature.id
                    }, [
                      _hoisted_41,
                      _createVNode(_component_router_link, {
                        tabindex: _ctx.showNavigation ? 0 : -1,
                        to: {
                  name: `Info${feature.view}`,
                  params: { feature: feature.collection },
                },
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('close')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.localize(feature)), 1)
                        ]),
                        _: 2
                      }, 1032, ["tabindex", "to"])
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.about")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_44,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'AboutUs' },
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.purpose")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_45,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'TermsAndConditions' },
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.terms")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_46,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'PrivacyPolicy' },
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.privacy")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_47,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'DeclarationConformity' },
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.declaration_conformity")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_48,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'Support' },
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.support")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              _createElementVNode("li", null, [
                _hoisted_49,
                _createVNode(_component_router_link, {
                  tabindex: _ctx.showNavigation ? 0 : -1,
                  to: { name: 'Cookies' },
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.$emit('close')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("navigation_list.cookies")), 1)
                  ]),
                  _: 1
                }, 8, ["tabindex"])
              ]),
              (_ctx.arrayOfFeatures.about_app)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayOfFeatures.about_app, (aboutApp) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: aboutApp.id
                      }, [
                        _hoisted_51,
                        _createVNode(_component_router_link, {
                          to: {
                  name: `Info${aboutApp.view}`,
                  params: { feature: aboutApp.collection },
                },
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.$emit('close')))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize(aboutApp)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_52, [
      _createVNode(_component_ChangeLanguage)
    ])
  ]))
}